import React from "react";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import FeatureComingSoon from "../FeatureComingSoon/FeatureComingSoon";

const CampaignFeatureComingSoon = ({ pageTitle }) => (
  <div className="rightside">
    <div className="rightcontent">
      <p>
        <strong>{pageTitle}</strong>
      </p>
      <CustomBreadcrumb
        items={[
          { text: "Home" },
          { text: "AI Campaigns" },
          { text: pageTitle, active: true },
        ]}
      />

      <div className="table-padding">
        <div className="headtitle">
          <p className="mb-0 heedprodct">{pageTitle}</p>
        </div>
        <hr className="m-0" />
        <FeatureComingSoon />
      </div>
    </div>
  </div>
);

export default CampaignFeatureComingSoon;
